import { render } from "./PointNumber.vue?vue&type=template&id=3ca87f09&scoped=true"
import script from "./PointNumber.vue?vue&type=script&lang=js"
export * from "./PointNumber.vue?vue&type=script&lang=js"

import "./PointNumber.vue?vue&type=style&index=0&id=3ca87f09&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca87f09"]])

export default __exports__